import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/head-icon.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ea474624"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "left"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo"
  })], -1);
});

var _hoisted_2 = {
  class: "right"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("首页");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("产品信息");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("新闻动态");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.height > 0 ? 'head-active' : 'head')
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/home",
    "active-class": "active",
    onClick: _ctx.handleTop
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/product",
    "active-class": "active",
    onClick: _ctx.handleTop
  }, {
    default: _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: "/news",
    "active-class": "active",
    onClick: _ctx.handleTop
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  }, 8, ["onClick"])])])], 2);
}